import React from 'react'
import { Form, Button, Input, Table, Pagination } from 'semantic-ui-react'

function UserTable({ users, userUsernameSearch, handleInputChange, handleDeleteUser, handleSearchUser, handlePaginationChange }) {
  let userList
  let activePage
  let totalPages
  if (!users) {
    userList = (
      <Table.Row key='no-user'>
        <Table.Cell collapsing textAlign='center' colSpan='6'>Нет пользователей</Table.Cell>
      </Table.Row>
    )
  } else {
    activePage = users.number
    totalPages = users.totalPages
    userList = users.content.map(user => {
      return (
        <Table.Row key={user.id}>
          <Table.Cell collapsing>
            <Button
              circular
              color='red'
              size='small'
              icon='trash'
              disabled={user.username === 'admin'}
              onClick={() => handleDeleteUser(user.username)}
            />
          </Table.Cell>
          <Table.Cell>{user.id}</Table.Cell>
          <Table.Cell>{user.username}</Table.Cell>
          <Table.Cell>{user.name}</Table.Cell>
          <Table.Cell>{user.phone}</Table.Cell>
          <Table.Cell>{user.role}</Table.Cell>
        </Table.Row>
      )
    })
  }

  return (
    <>
      <Form onSubmit={handleSearchUser}>
        <Input
          action={{ icon: 'search' }}
          name='userUsernameSearch'
          placeholder='Search by Username'
          value={userUsernameSearch}
          onChange={handleInputChange}
        />
      </Form>
      <Table compact striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1}/>
            <Table.HeaderCell width={1}>ID</Table.HeaderCell>
            <Table.HeaderCell width={3}>Email</Table.HeaderCell>
            <Table.HeaderCell width={4}>Имя</Table.HeaderCell>
            <Table.HeaderCell width={5}>Телефон</Table.HeaderCell>
            <Table.HeaderCell width={2}>Роль</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {userList}
        </Table.Body>
      </Table>
      <Pagination
        activePage={activePage+1}
        boundaryRange={1}
        onPageChange={handlePaginationChange}
        size='mini'
        totalPages={totalPages}
      />
    </>
  )
}

export default UserTable
